
function initSwiperFeature() {
	if (typeof Swiper === 'undefined') {
		setTimeout(initSwiperFeature, 100);
		return;
	}

	window.swiperFeature = new Swiper('#pwm-ld-25-bigupdate-header .swiper-feature', {
		slidesPerView: 1,
		loop: true,
		navigation: {
			prevEl: '#pwm-ld-25-bigupdate-header .swiper-btn-prev',
			nextEl: '#pwm-ld-25-bigupdate-header .swiper-btn-next',
		},
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initSwiperFeature);
} else {
	initSwiperFeature();
}

window.addEventListener("load", function () {


});
